<template>
    <div class="u-page-wrapper pb-56">
        <div class="mb-16">
            <div class="u-page-headline u-flex u-flex--space-between u-flex--vertical-center">
                <h2 class="u-size-body">
                    <i class="el-icon-medal" aria-hidden="true"></i>
                    Hauptuntersuchung
                </h2>

                <el-button type="text" icon="el-icon-plus" circle @click="showAddGeneralInspectionModal = true" />
            </div>

            <hint class="mt-16">Das Auto muss alle 2 Jahre zur Hauptuntersuchung.</hint>

            <inspection-card
                v-if="generalInspectionDates.length"
                :dates="generalInspectionDates"
                v-bind="generalInspectionInfo"
                class="mt-16"
            />
            <p v-else class="u-size-14 mt-16 text-primary">Du hast noch keine Hauptuntersuchung hinzugefügt.</p>
        </div>

        <div>
            <div class="u-page-headline u-flex u-flex--space-between u-flex--vertical-center">
                <h2 class="u-size-body">
                    <i class="el-icon-date" aria-hidden="true"></i>
                    Inspektion
                </h2>

                <el-button type="text" icon="el-icon-plus" circle @click="showAddInspectionModal = true" />
            </div>

            <hint class="my-16">Das Auto muss alle 12 Monate zur Inspektion.</hint>

            <template v-if="inspectionDates.length">
                <inspection-card
                    v-if="inspectionDates"
                    :dates="inspectionDates"
                    v-bind="inspectionInfo"
                    class="my-16"
                />

                <el-row
                    v-for="(item, i) in inspectionDates"
                    :key="`inspection-${i}`"
                    class="inspection-item mb-24 u-size-14"
                    :gutter="12"
                >
                    <el-col :span="12" class="tire__headline">Datum:</el-col>
                    <el-col :span="12" class="tire__value">{{ $date(new Date(item.date), 'dd.MM.yyyy') }}</el-col>
                    <el-col :span="12" class="tire__headline">Kilometerstand:</el-col>
                    <el-col :span="12" class="tire__value">{{ item.mileage ? `${item.mileage} km` : 'N/A' }}</el-col>
                    <el-col :span="12" class="tire__headline">Kosten:</el-col>
                    <el-col :span="12" class="tire__value">{{ item.costs ? `${item.costs} €` : 'N/A' }}</el-col>
                    <el-col :span="12" class="tire__headline">Info:</el-col>
                    <el-col :span="12" class="tire__value">
                        <el-popover
                            v-if="item.info"
                            placement="bottom"
                            width="200"
                            trigger="click"
                            :content="item.info">
                            <el-button slot="reference" class="p-0" icon="el-icon-info" type="text"></el-button>
                        </el-popover>
                        <span v-else>N/A</span>
                    </el-col>
                </el-row>
            </template>
            <p v-else class="u-size-14 text-primary">Du hast noch keine Inspektion hinzugefügt.</p>
        </div>

        <add-general-inspection-modal
            v-model="showAddGeneralInspectionModal"
            @reload="loadDates"
        />
        <add-inspection-modal
            v-model="showAddInspectionModal"
            @reload="loadDates"
        />
    </div>
</template>

<script>
import {
    getGeneralInspectionCard,
    getInspectionsCard,
    loadGeneralInspection, loadInspections,
} from '@/lib/inspections'
import InspectionCard from '@/components/modals/InspectionCard'
import AddGeneralInspectionModal from '@/components/modals/AddGeneralInspectionModal'
import AddInspectionModal from '@/components/modals/AddInspectionModal'
import Hint from '@/components/Hint'

export default {
    components: { Hint, AddInspectionModal, InspectionCard, AddGeneralInspectionModal },

    data () {
        return {
            generalInspectionDates: [],
            inspectionDates: [],
            showAddGeneralInspectionModal: false,
            showAddInspectionModal: false,
        }
    },

    computed: {
        generalInspectionInfo () {
            return getGeneralInspectionCard()
        },

        inspectionInfo () {
            return getInspectionsCard()
        },
    },

    mounted () {
        this.loadDates()
    },

    methods: {
        async loadDates () {
            try {
                this.generalInspectionDates = await loadGeneralInspection()
                this.inspectionDates = await loadInspections()
            } catch (e) {
                this.$notify({
                    title: 'Error',
                    message: e.message,
                    type: 'error',
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.inspection-item {
    padding-bottom: $spacing-unit-16;
    border-bottom: 1px solid rgba($white, 0.2);
}
</style>
